module.exports = __webpack_public_path__ + "img/greg-washington.934ba593.jpg";